import apiService from '../../../apiService'
import Notification from '../../../../../../../../resources/js/notification'

export default {
  namespaced: true,
  state: {
    interview: {}
  },
  mutations: {
    set (state, interview) {
      state.interview = interview
    }
  },
  actions: {
    fetch ({ state, commit }, domain) {
      apiService.getFormsInterview(domain)
        .then(response => {
          commit('set', response.data.interview)
          window.vue.$emit('formsInterviewLoaded')
        })
        .catch(() => {
          Notification.notifyError({
            title: 'Ошибка',
            content: 'Не удалось загрузить ссылку на анкетирование.'
          })
        })
    }
  }
}
